import React, { useEffect, useState } from "react"
import { useHistory } from "react-router"
import Button from "../../../../components/Button"
import Table from "../../../../components/Table"
import { getAllCenters } from "../../../../core/services/api"
import "./ManageCenters.scss"
import { MANAGE_CENTER_COLUMNS } from "./ManageCentersColumns"
import { useSelector } from "react-redux"


export default function ManageCenters() {
  const history = useHistory()
  const [centers, setAllCenters] = useState([])
  // @ts-ignore
  let readOnly = useSelector((state) => state?.user?.readOnly)

  useEffect(() => {
    getAllCenters()
      .then((res) => {
        setAllCenters(res)
      })
      .catch((err) => {
        console.log("err", err)
      })
  }, [])

  function onAddCenter(id: any = null) {
    if (id) {
      history.push(`/manageCenters/${id}`)
    } else {
      history.push(`/manageCenters/add`)
    }
  }

  return (
    <div className="manage-centers-wrapper">
      <div className="heading">
        <div
          className="back-image"
          onClick={() => {
            history.push("/home")
          }}
        >
          <img
            src={"../../../assets/images/back-icon.svg"}
            height={"60px"}
            width={"60px"}
            alt="back button"
          />
        </div>

        <div className="header-text">Manage Centers</div>
      </div>

      <div className="manage-centers-container">
        <div className="d-flex justify-content-end">
          <Button text="Add new center"
            disabled={readOnly}
            onClick={() => onAddCenter(null)} id="add-new-center" />
        </div>
        <div>
          <Table
            data={centers}
            columns={MANAGE_CENTER_COLUMNS}
            globalFilterRequired={false}
            onRowClick={(id: any) => onAddCenter(id)}
            onColClick={() => null}
          />
        </div>
      </div>
    </div>
  )
}
